// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3vyJN","footer":"ModalUpdate_footer__1oAyy"};